import { isDevEnv } from '../env'
import { GenericStorage } from './storage'

const MAX_LOG_HISTORY = 50

interface DiagnosticLog {
    type: string
    timestamp: string
    message?: string
    data?: any
}

const storage = new GenericStorage<DiagnosticLog[]>('DIAGNOSTIC_LOG')

export const append = (type: string, data?: any, message?: string): void => {
    if (isDevEnv()) console.warn('Appending diagnostic:', type, data)
    const logs = storage.read() ?? []
    const timestamp = new Date().toISOString()
    logs.push({ type, timestamp, message, data })
    storage.store(logs.splice(0, MAX_LOG_HISTORY))
}

export const dump = () => {
    const logs = storage.read() ?? []
    return JSON.stringify(logs, null, 4)
}

export const label = () => `diagnostics-${Date.now()}`
